class FetchWrapper {
    constructor(headers = {}) {
        this._additionalHeaders = { ...headers };
    }

    static get instance() {
        return new FetchWrapper();
    }

    addHeaders(headers) {
        return new FetchWrapper({
            ...this._additionalHeaders,
            ...headers,
        });
    }

    _createHeaders() {
        return {
            ...this._additionalHeaders
        };
    }

    async get(url, params, signal) {
        return await fetch(
            params ? `${url}?${params}` : url,
            {
                method: 'GET',
                headers: this._createHeaders(),
                signal
            }
        );
    }

    async postData(url, data, signal) {
        return await fetch(
            url,
            {
                method: 'POST',
                headers: this._createHeaders(),
                body: data,
                signal
            }
        );
    }

    async post(url, data, signal) {
        return await fetch(
            url,
            {
                method: 'POST',
                headers: this._createHeaders(),
                body: data,
                signal
            }
        );
    }

    async put(url, data, signal) {
        return await fetch(
            url,
            {
                method: 'PUT',
                headers: this._createHeaders(),
                body: data,
                signal
            }
        );
    }

    async postWithCredentials(url, data, signal) {
        return await fetch(
            url,
            {
                method: 'POST',
                credentials: 'include',
                headers: this._createHeaders(),
                body: data,
                signal
            }
        );
    }
}

export default FetchWrapper;
